import { useQuery } from '@hooks/reactQuery';

import { getOrganizationDashboardAssetSummary } from '@api/dashboardPO';

import { extractQueryParams } from '@utils/common';

import { IId } from '@interfaces/common/common';

import { refetchOptions } from '@constants/common';
import { DASHBOARD_ASSETS_SUMMARY_ORGANIZATION } from '@constants/queryKeys';

const useQueryOrganizationDashboardAssetsSummary = ({ id }: IId<string | undefined>) => {
	const {
		data: organizationDashboardAssetsSummary,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [DASHBOARD_ASSETS_SUMMARY_ORGANIZATION, id],
		queryFn: extractQueryParams(getOrganizationDashboardAssetSummary),
		enabled: [!!id],
		...refetchOptions,
	});

	return {
		organizationDashboardAssetsSummary,
		isLoadingOrganizationDashboardAssetsSummary: (isLoading && !!organizationDashboardAssetsSummary) || isFetching,
	};
};

export default useQueryOrganizationDashboardAssetsSummary;
